import { Component } from '@angular/core';
import { CartService } from '@core/services/cart/cart.service';

@Component({
    selector: 'app-cart-notification',
    templateUrl: './cart-notification.component.html',
    styleUrls: ['./cart-notification.component.scss'],
    standalone: true
})
export class CartNotificationComponent {

  constructor(
    private cartService: CartService
  ) { }

  getTotalCartCount() {
    return this.cartService.getQuantity();
  }

  getFinalCartPrice() {
      return this.cartService.getFinalCartPrice();
  }
}
